/**
 * @GENERATED from Figma node 693:15882
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const AirtableBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBF00"
      d="M10.826 3.23 2.627 6.548a.533.533 0 0 0 .006.996l8.235 3.194c.723.283 1.53.283 2.253 0l8.234-3.194a.533.533 0 0 0 .006-.996L13.163 3.23a3.09 3.09 0 0 0-2.337 0"
    />
    <path
      fill="#ED3049"
      d="M10.578 12.895 7.856 14.18l-.277.13-5.747 2.693C1.47 17.174 1 16.915 1 16.52V9.03c0-.142.073-.266.175-.36a.6.6 0 0 1 .139-.1.59.59 0 0 1 .5-.036l8.716 3.377c.446.171.482.778.048.984"
    />
    <path
      fill="#B22437"
      d="M1.616 8.493c-.109 0-.211.03-.29.076-.048.03-.096.06-.138.1l6.668 5.511 2.723-1.285a.53.53 0 0 0 .307-.477.54.54 0 0 0-.349-.507L1.82 8.534a.5.5 0 0 0-.204-.041"
    />
    <path
      fill="#26B5F8"
      d="M12.723 12.483v7.98c0 .377.392.636.753.5l9.174-3.483a.54.54 0 0 0 .35-.5V9c0-.378-.392-.637-.753-.501l-9.174 3.483a.54.54 0 0 0-.35.5"
    />
  </svg>
);
const ForwardRef = React.forwardRef(AirtableBright);
export { ForwardRef as AirtableBright };
